import React from 'react';
import { Banner } from './Banner';

type JobDetailsAwaitReleaseBannerProps = {
  hours?: string;
  proDidSwapRequest?: boolean;
  proHasSwapRequestPendingFacility?: boolean;
  proAwaitingDropRequest?: boolean;
  proAwaitingReleaseRequest?: boolean;
};

export const JobDetailsAwaitReleaseBanner = ({
  hours,
  proDidSwapRequest,
  proHasSwapRequestPendingFacility,
  proAwaitingDropRequest,
  proAwaitingReleaseRequest,
}: JobDetailsAwaitReleaseBannerProps) => {
  const getMessage = () => {
    if (proDidSwapRequest || proHasSwapRequestPendingFacility) {
      return 'Swap request pending approval';
    }
    if (proAwaitingDropRequest) {
      return 'Drop request pending approval';
    }
    if (proAwaitingReleaseRequest) {
      return `Release approved for ${hours}hrs`;
    }
  };

  return (
    <Banner
      bgColor="state.warning.backing-1"
      iconColor="state.warning.secondary"
      title={getMessage()}
    />
  );
};
